export const SUPER = 'AlertaDIS_SUPER_USER';
export const ADMIN = 'AlertaDIS_ADMIN';
export const USER = 'AlertaDIS_USER';

const SUPER_bbox = [ -50.2313,-26.2374,-48.0238,-24.4168 ];
const ADMIN_bbox = [ -50.2313,-26.2374,-48.0238,-24.4168 ];
const USER_bbox = [ -52.0334,-24.4686,-49.5484,-22.5391 ];

export const managementRoleBBOX = (roles) => {
    const managmentRoles = [SUPER, ADMIN, USER];
    let bbox = undefined;

    const findRole = roles.find((role) => managmentRoles.includes(role));

    if(findRole){
        switch (findRole) {
            case SUPER:
                bbox = SUPER_bbox;
                break;
            case ADMIN:
                bbox = ADMIN_bbox;
                break;
            case USER:
                bbox = USER_bbox;
                break;
            default:
                break;
        }
    }

    return bbox;
}